import React from 'react';

import { useLoginPage } from '../../api/hooks/useLoginPage.hook';
import { useMarketplacePage } from '../../api/hooks/useMarketplace.hook';
import { DefaultHeader } from '../../components/_shared/header/default-header/default-header';
import { HeaderFooterWrapper } from '../../components/_shared/header-footer-wrapper/header-footer-wrapper';
import { MetaTagsResolver } from '../../components/_shared/meta-tags-resolver/meta-tags-resolver';
import { Stage } from '../../components/_shared/stage/stage';
import MainFilterForm from '../../components/marketplace/main-filter-form/main-filter-form';
import MarketplaceInstanceTeaser from '../../components/marketplace/marketplace-instance-teaser/marketplace-instance-teaser';
import MarketplaceModalFilter from '../../components/marketplace/marketplace-modal-filter/marketplace-modal-filter';
import UpperFilter from '../../components/marketplace/upper-filter/upper-filter';
import styles from './marketplace.module.scss';

const Marketplace = () => {
    const data = useMarketplacePage();
    if (!data) {
        return <div />;
    }
    return (
        <HeaderFooterWrapper
            header={<DefaultHeader availableLanguages={data?.localizations} />}
            stage={
                <Stage
                    size={'Small'}
                    orientation={'LEFT'}
                    description={''}
                    inverted={true}
                    titleVariant={data.stage?.headline?.style}
                    title={data?.stage?.headline?.headlineContent ?? ''}
                    background={data?.stage?.background?.url}
                />
            }
        >
            <MetaTagsResolver tags={data?.meta} />
            <div className={styles['marketplace-content']}>
                <div className={styles['marketplace-content-left']}>
                    <MarketplaceModalFilter />
                    <div className={styles['marketplace-content-left-desktop']}>
                        <MainFilterForm />
                    </div>
                </div>
                <div className={styles['marketplace-content-right']}>
                    <UpperFilter />
                    <MarketplaceInstanceTeaser />
                </div>
            </div>
        </HeaderFooterWrapper>
    );
};

Marketplace.dataHooks = [
    useLoginPage,
    useMarketplacePage,
    ...MetaTagsResolver.dataHooks
];

export default Marketplace;
